import { useMutation } from "@tanstack/react-query";
import {
  groupUpdate,
  GroupUpdateParams,
} from "common/api/citajteo/dl_group/citajteo_group";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseGroupUpdateParams = {
  invalidateKeys?: string[];
  invalidateKeysArray?: string[][];
  successHandle?: Function;
  errorHandle?: Function;
};

export const useGroupUpdate = (hookParams?: UseGroupUpdateParams) => {
  const { invalidateQueriesByKeys, invalidateQueriesArraysByKeys } =
    useInvalidateQueryByKeys();
  const { mutate: groupUpdateMutate } = useMutation({
    mutationFn: async (params: {
      id: string;
      updatePayload: GroupUpdateParams;
    }) => {
      const response = await groupUpdate(params.id, params.updatePayload);

      if (!response) {
        throw new Error("groupUpdate failed");
      }

      return response;
    },
    onSuccess: (response) => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      } else if (hookParams?.invalidateKeysArray) {
        invalidateQueriesArraysByKeys(hookParams.invalidateKeysArray);
      }

      if (hookParams?.successHandle) {
        hookParams.successHandle(response);
      }
    },
    onError: (error) => {
      if (hookParams?.errorHandle) {
        hookParams.errorHandle(error);
      }
    },
  });

  return { groupUpdateMutate };
};
